import { USER_ROLE, track } from '@/common/pendo/agent'

import {
  CLOSE_DOCUMENTS_UPLOAD_FILES,
  OPEN_DOCUMENTS_UPLOAD_FILES,
  START_UPLOAD,
} from './action_types'
import { RESET_SELECTED_DOCUMENTS, SET_IS_OPEN } from './mutation_types'

export const actions = {
  [OPEN_DOCUMENTS_UPLOAD_FILES]: function ({ commit }) {
    commit(SET_IS_OPEN, true)
  },
  [CLOSE_DOCUMENTS_UPLOAD_FILES]: function ({ commit }) {
    commit(SET_IS_OPEN, false)
    commit(RESET_SELECTED_DOCUMENTS)
  },
  [START_UPLOAD]: function ({ dispatch, state, rootGetters }) {
    dispatch('appUploadHandler/ADD_FILES_TO_UPLOAD', state.selectedDocuments, { root: true })
    track('document_uploaded', {
        project_mnemo: rootGetters['room/roomMnemo'],
        user_role: rootGetters['room/isCurrentUserPm'] ? USER_ROLE.PROJECT_MANAGER : USER_ROLE.GUEST,
        upload_source: 'closd',
    })
    dispatch(CLOSE_DOCUMENTS_UPLOAD_FILES)
  },
}
